export default {
    getBoxesList: (env, boxes) => {
        return {
            url: `/testbench/${env}/boxes`,
            method: 'GET',
            get_params: {
                boxes
            }
        };
    },
    getBoxDetails: (env, boxMac) => {
        return {
            url: `/testbench/${env}/box`,
            method: 'GET',
            get_params: {
                boxMac
            }
        };
    },
    setCodePack: (env, boxMac, codePack) => {
        return {
            url: `/testbench/${env}/box/update-code-pack`,
            method: 'PATCH',
            patch_params: {
                boxMac,
                codePack
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/data/Boxes/api.js